import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import OurProcess from "../components/OurProcess";
import HeroBanner from "../components/HeroBanner";
import ContactUs from "../components/organisms/ContactUs";

import { useTranslation } from "react-i18next";
import "../i18n"; // Ensure this import is present
import IntroSection from "../components/IntroSection";
import OurApproach from "../components/OurApproach";
import RootCause from "../components/RootCause";

const Home = () => {
  const navigate = useNavigate();
  const [isHovered, setIsHovered] = useState(false);

  const handleEnterClick = () => {
    navigate("/main");
  };

  const { t, i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  const buttonStyle = {
    backgroundColor: isHovered ? "#f5e9dc" : "#edd6be",
    fontSize: "20px",
    padding: "5px 15px",
    color: "#A67B5B",
    border: "1px solid beige",
    cursor: "pointer",
    transition: "background-color 0.3s",
  };

  return (
    <div>
      {/* <h1>Munish Nutrition</h1>

      <p>{t("description")}</p>
      <button
        style={buttonStyle}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        onClick={() => changeLanguage("en")}
      >
        English
      </button>
      <button
        style={buttonStyle}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        onClick={() => changeLanguage("de")}
      >
        Deutsch
      </button>

      <p>“Every human deserves a good quality of Life.”</p>
      <button
        style={buttonStyle}
        onClick={handleEnterClick}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {" "}
        Enter
      </button> */}

      <HeroBanner />
      <IntroSection />
      <OurApproach />
      <RootCause />
      <OurProcess />
      <ContactUs />

      {/* <button style={{ backgroundColor: '#f5e9dc', fontSize: '20px', padding:'5px 15px', color: '#A67B5B', borderColor: 'beige' }} onClick={handleEnterClick}>Enter</button> */}
    </div>
  );
};

export default Home;
